module.exports = __webpack_public_path__ + "static/media/display21.aaaa44e9.jpg";